import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ContentComponent } from './content.component';
import { BreadcrumbsModule } from '../bread-crumbs/bread-crumbs.module';
import { AngularMaterialModule } from 'src/app/material.module';

@NgModule({
    imports: [CommonModule, RouterModule,BreadcrumbsModule,AngularMaterialModule],
    exports: [ContentComponent],
    declarations: [ContentComponent]
})
export class ContentModule {}
